import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";

const handleI18nHeaders = rmI18n => {
  let force_country_code = null;
  if (process.browser) {
    force_country_code = localStorage.getItem("force_country_code");
  }

  if (force_country_code) {
    axios.defaults.headers.post["X-Force-Country"] = force_country_code;
    axios.defaults.headers.get["X-Force-Country"] = force_country_code;
    axios.defaults.headers.delete["X-Force-Country"] = force_country_code;
    axios.defaults.headers.put["X-Force-Country"] = force_country_code;
    axios.defaults.headers.patch["X-Force-Country"] = force_country_code;
  } else {
    delete axios.defaults.headers.post["X-Force-Country"];
    delete axios.defaults.headers.get["X-Force-Country"];
    delete axios.defaults.headers.delete["X-Force-Country"];
    delete axios.defaults.headers.put["X-Force-Country"];
    delete axios.defaults.headers.patch["X-Force-Country"];
  }

  let lang = "";
  if (process.browser) {
    if (localStorage.getItem("active_langtag")) {
      lang = localStorage
        .getItem("active_langtag")
        .replace("_", "-")
        .toLowerCase();
    } else {
      lang = navigator.language;
    }

    axios.defaults.headers.post["Accept-Language"] = lang;
    axios.defaults.headers.get["Accept-Language"] = lang;
    axios.defaults.headers.put["Accept-Language"] = lang;
    axios.defaults.headers.patch["Accept-Language"] = lang;
    axios.defaults.headers.delete["Accept-Language"] = lang;
  }

  // En caso de ser necesario (por ejemplo, detección de lengua del usuario)
  // necesitamos eliminar los settings impuestos por el usuario al realizar
  // la petición. Esto se realiza por ejemplo al cargar los lenguajes
  // aceptados por el navegador del usuario (store i18nmap.LOAD_BEST_LANGTAG).
  if (rmI18n) {
    delete axios.defaults.headers.post["X-Force-Country"];
    delete axios.defaults.headers.get["X-Force-Country"];
    delete axios.defaults.headers.delete["X-Force-Country"];

    if (process.browser) {
      axios.defaults.headers.post["Accept-Language"] = navigator.language;
      axios.defaults.headers.get["Accept-Language"] = navigator.language;
      axios.defaults.headers.put["Accept-Language"] = navigator.language;
      axios.defaults.headers.patch["Accept-Language"] = navigator.language;
      axios.defaults.headers.delete["Accept-Language"] = navigator.language;
    } else {
      // We're in SSR mode.
      // Get the Accepted-Language header of the bot that is making the request
      // or fallback to English?
      // Notes: Pass the headers from the renderToString()'s first parameter.
      // Notes: This will be passed to the context parameter of the default
      // function in main.server.js
      // Notes: Find a way to pass it somehow in the app itself so we can read
      // it here.
      lang = "es-MX";
      axios.defaults.headers.post["Accept-Language"] = lang;
      axios.defaults.headers.get["Accept-Language"] = lang;
      axios.defaults.headers.put["Accept-Language"] = lang;
      axios.defaults.headers.patch["Accept-Language"] = lang;
      axios.defaults.headers.delete["Accept-Language"] = lang;
    }
  }
};

const handleSiteContextHeaders = () => {
  axios.defaults.headers.get["Site-Context"] =
    process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
  axios.defaults.headers.post["Site-Context"] =
    process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
  axios.defaults.headers.put["Site-Context"] =
    process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
  axios.defaults.headers.patch["Site-Context"] =
    process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
  axios.defaults.headers.delete["Site-Context"] =
    process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
};

export const getAxiosConfig = (extraconf = {}, rmI18n = false) => {
  handleI18nHeaders(rmI18n);

  // Make sure to set the site context. We need that in the backend so we can
  // find out from where did the request originated.
  handleSiteContextHeaders();

  // strange bug found with this header. Its necessary to set
  // a config globally to take effect
  let jwt = false;
  if (process.browser) {
    jwt = localStorage.getItem("jwt");
  }
  const headers = {};

  if (jwt) {
    axios.defaults.headers.get["Authorization"] = `JWT ${jwt}`;
    headers["Authorization"] = `JWT ${jwt}`;
  } else {
    delete axios.defaults.headers.get["Authorization"];
  }

  const conf = Object.assign(
    {
      crossDomain: true,
      headers,
    },
    extraconf
  );
  return conf;
};

export const getAxiosConfigNoAuth = (extraconf = {}, rmI18n = false) => {
  handleI18nHeaders(rmI18n);

  // Make sure to set the site context. We need that in the backend so we can
  // find out from where did the request originated.
  handleSiteContextHeaders();

  // Make sure to append "SSR" to the User-Agent. We need that in the backend
  // so we can tell Core to skip geo limits.
  // Note that this code diesn't exist in the getAxiosConfig() method as SSR
  // will never run authenticated requests.
  if (!process.browser) {
    axios.defaults.headers.get["User-Agent"] = "SSR";
  }

  delete axios.defaults.headers.get["Authorization"];
  const conf = Object.assign(
    {
      crossDomain: true,
    },
    extraconf
  );
  return conf;
};

export const getApiUri = () => {
  const hostname =
    process.env.VUE_APP_BACKEND_ADDRESS || window.location.hostname;
  let port = process.env.VUE_APP_BACKEND_PORT;
  const protocol = process.env.VUE_APP_BACKEND_PROTOCOL;
  const suffix = process.env.VUE_APP_BACKEND_API_SUFFIX;

  let uri = `${protocol}://${hostname}`;
  if (port.length > 0) {
    return `${uri}:${port}${suffix}`; // do not put ending slash
  }
  return `${uri}${suffix}`; // do not put ending slash
};
